"use client";

import type { Dispatch, ReactNode, SetStateAction } from "react";
import React, { useContext, useState } from "react";
interface TProps {
  children?: ReactNode;
}
interface IAuthContext {
  activeForm?: string | null;
  remember?: boolean;
  setActiveForm: Dispatch<SetStateAction<string>>;
  setRemember: Dispatch<SetStateAction<boolean>>;
}
const defaultState: IAuthContext = {
  activeForm: null,
  setActiveForm: () => {},
  remember: false,
  setRemember: () => {}
};
const AuthContext = React.createContext<IAuthContext>(defaultState);
export default function AuthProvider({
  children
}: TProps) {
  const [activeForm, setActiveForm] = useState<string>("LOGIN");
  const [remember, setRemember] = useState<boolean>(false);
  return <AuthContext.Provider value={{
    activeForm,
    setActiveForm,
    remember,
    setRemember
  }}>
      {children}
    </AuthContext.Provider>;
}
export const useAuthContext = () => useContext(AuthContext);